import { makeStyles } from '@material-ui/styles'
const WIDTH = 400
const DELETE_WIDTH = 35

const useStyles = makeStyles(theme => ({
  root: {
    position: 'absolute',
    top: 57,
    right: 25,
  },
  listRoot: {
    backgroundColor: theme.palette.common.white,
    overflowY: 'auto',
    maxHeight: 400,
    width: WIDTH,
    '@global': {
      '.MuiListItem-gutters': {
        padding: 0
      },
      '.MuiListItem-root': {
        padding: 0
      },
      '.MuiListItemText-root': {
        marginTop: 0,
        marginBottom: 0
      }
    }
  },
  header: {
    backgroundColor: theme.palette.grey[200]
  },
  refresh: {
    display: 'inline-block',
    position: 'absolute',
    right: 5,
    top: 0
  },
  loading: {
    display: 'inline-block',
    position: 'absolute',
    right: 65,
    top: 5
  },
  noItem: {
    padding: theme.spacing(2)
  },
  item: {
    '&:hover': {
      backgroundColor: theme.palette.grey[100]
    }
  },
  file: {
    cursor: 'pointer',
    display: 'inline',
    fontSize: '16px',
    maxHeight: 42,
    maxWidth: WIDTH - DELETE_WIDTH - theme.spacing(5),
    position: 'absolute',
    padding: 0,
    paddingTop: theme.spacing(1),
    marginLeft: theme.spacing(2),
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  newFile: {
    fontWeight: 'bold'
  },
  delete: {
    width: DELETE_WIDTH,
    padding: theme.spacing(1),
    display: 'inline-block'
  }
}))

export {
  useStyles
}
